import $ from 'jquery';
import React, { Component } from 'react';
import ReactTooltip from 'react-tooltip';
import RDP_CONFIG from '../../config';
import {DamService} from '../../services/dam';
import {UserService} from '../../services/user';
import { MessagesService } from '../../services/messages';
import { WorkflowsService } from '../../services/workflows';
import { DemandsService } from '../../services/demands';
import { ActivitiesService } from '../../services/activities';
import './element-activities.css';

export default class ElementActivities extends Component {
  constructor(props) {
    super(props);

    this.onChange = this.onChange.bind(this);
    this.onClose = this.onClose.bind(this);
    this.getProcesses = this.getProcesses.bind(this);
    this.canCreateInstruction = this.canCreateInstruction.bind(this);

    this.titleRef = React.createRef();
    this.goalRef = React.createRef();

    this.state = {
      "content": this.props.content,
      "render_template_options": false,
      "render_template_new": false,
      "templates": null,
      "template_name": null,
      "saving_template": false,
      "render_template_save_success": false,
      "render_template_save_error": false,
      "render_templates_list": false,
      "applying_template": false,
      "template_search_term": "",
      "processes": null,
      "render_processes": false,
      "selected_process": null,
      "selected_process_properties": null,
      "demand_title": "",
      "demand_goal": "",
      "creating_demand": false,
      "created_demand": false,
      "all_activities_length": 0,
      "completed_activities_length": 0,
      "current_demand": null
    };
  }

  componentWillMount() {
    this.getProcesses()
  }

  onChange(type, data) {
    var content = this.state.content;
    this.props.onChange(content);
  }

  onContentChange(content) {
    this.setState({
      "content": content
    })
  }
  saveProperties() {
    this.props.onChange(this.state.content);
  }

  onAlertSuccessClose() {
    this.setState({
      "render_template_save_success": false
    })
  }

  onAlertErrorClose() {
    this.setState({
      "render_template_save_error": false
    })
  }

  openTemplatesList() {
    this.getDAMTemplates();

    this.setState({
      "render_template_options": false,
      "render_templates_list": true
    });
  }

  closeTemplatesList() {
    this.setState({
      "templates": null,
      "render_template_options": false,
      "render_templates_list": false
    });
  }

  mergeProperties(allProperties, compositionProperties) {
    var temp = [];
    for (var i = 0; i < allProperties.length; i++) {
      for (var j = 0; j < compositionProperties.length; j++) {
        if (allProperties[i].uid === compositionProperties[j]) {
          allProperties[i].value = compositionProperties[j].value;
        };
        temp.push(allProperties[i]);
      };
    };

    return temp;
  }

  async getAssignedProcess() {
    var composition = this.props.composition;
    var workflows = composition.workflows;
    var objectUid = this.props.object_id;
    var processes = this.state.processes;

    var current = null;

    for (var i = 0; i < processes.length; i++) {
      for (var j = 0; j < workflows.length; j++) {
        if (processes[i].uid === workflows[j].process.uid && workflows[j].uid === objectUid) {
          current = processes[i];
          var originalProps = current.properties;
          var compositionProps = workflows[j].process.properties;
          for (var k = 0; k < originalProps.length; k++) {
            for (var l = 0; l < compositionProps.length; l++) {
              if (originalProps[k].uid === compositionProps[l].uid) {
                originalProps[k].value = compositionProps[l].value;
              };
            };
          };
        };
      };
    };

    
    if (workflows && processes && current) {
      this.setState({
        "selected_process": current.uid,
        "selected_process_properties": current.properties
      })
    }
  }

  async getProcesses() {
    var _this = this;
    var activeProject = UserService.getActiveProject();
    var objectType = this.getObjectType();
    var filter = "";
    if (objectType === "video") filter = "&filter_outputs=application/mp4&filter_outputs=video/mp4";
    if (objectType === "audio") filter = "&filter_outputs=audio/mp3&filter_outputs=audio/mpeg";
    if (objectType === "image") filter = "&filter_outputs=image/png&filter_outputs=image/jpeg&filter_outputs=image/jpg&filter_outputs=image/gif";
    if (objectType === "text") filter = "&filter_outputs=text/plain&filter_outputs=application/msword";

    var processes = await WorkflowsService.getProcesses(filter);
    this.setState({
      "processes": processes
    }, function() {
      _this.getAssignedProcess()
    })
  }

  renderMessages() {
    var _this = this;
    var messages = this.state.messages;
    var users = this.props.users;
    var tempMessages = [];
    if (messages && users) {
      for (var i = 0; i < messages.length; i++) {
        if (messages[i].user_uid === _this.props.user_uid) {
          messages[i].my = true;
        };
        for (var j = 0; j < users.length; j++) {
          if (messages[i].user_uid === users[j].uid) {
            messages[i].user = users[j];
            tempMessages.push(messages[i]);
          };
        };
      };
    } else {
      return null;
    };

    return tempMessages;
  }

  getNameInitials(first, last) {
    return first.charAt(0) + last.charAt(0);
  }

  onClose() {
    clearInterval(this.myInterval);
    this.props.onClose()
  }

  onOpenWorkflows() {
    this.setState({
      "render_processes": true
    });
  }

  onCloseWorkflows() {
    this.setState({
      "render_processes": false
    });
  }

  async getOriginalUid() {
    var user = UserService.getUser();
    const original = await DamService.getFileOriginalUid(this.props.content_uid, user.access_token);
    return original.original_uid;
  }

  changeComposition(demandUid, objectId, objectType) {
    var composition = this.props.composition;
    if (typeof composition.demands === "undefined") {
      composition.demands = [];
    };

    composition.demands.push({
      "demand_uid": demandUid,
      "object": objectId,
      "object_type": objectType
    })

    this.props.onCompositionChange(composition);
  }

  getObjectType() {
    var objectType = "";
    var composition = this.props.composition;
    var objectId = this.props.object_id;
    var obj = composition.structure.find(item => item.id === objectId);

    if (obj.type.search("video") > -1) {
      objectType = "video"
    } else if (obj.type.search("audio") > -1) {
      objectType = "audio"
    } if (obj.type.search("image-") > -1 ||
    obj.type.search("hotspots-") > -1) {
      objectType = "image"
    } if (obj.type.search("text-") > -1 ||
    obj.type.search("text-") > -1 ||
    obj.type.search("list-") > -1 ||
    obj.type.search("statement-") > -1 ||
    obj.type.search("tabs") > -1 ||
    obj.type.search("accordion-") > -1 ||
    obj.type.search("text-") > -1 ||
    obj.type.search("divider-") > -1 ||
    obj.type.search("forum-") > -1 ||
    obj.type.search("iframe") > -1 ||
    obj.type.search("quiz") > -1) {
      objectType = "text"
    };

    return objectType;
  }

  onChangeProcessPropertyValue(uid, value) {
    var properties = this.state.selected_process_properties;
    for (var i = 0; i < properties.length; i++) {
      if (properties[i].uid === uid) {
        properties[i].value = value;
      };
    };

    this.setState({
      "selected_process_properties": properties
    });
  }

  async createInstruction() {
    var objectUid = this.props.object_id;
    var selected_process = this.state.selected_process;
    var selected_process_properties = this.state.selected_process_properties;
    var composition = this.props.composition;
    if (composition.workflows === undefined) composition.workflows = [];
    var workflows = composition.workflows;
    if (workflows.find(item => item.uid === objectUid)) {
      for (var i = 0; i < workflows.length; i++) {
        if (workflows[i].uid === objectUid) {
          workflows[i].process.uid = selected_process;
          workflows[i].process.properties = selected_process_properties;
        }
        
      }
    } else {
      composition.workflows.push({
        "uid": objectUid,
        "process": {
          "uid": selected_process,
          "properties": selected_process_properties
        }
      });
    }

    this.props.onCompositionChange(composition);
    this.props.onClose();
  }

  selectProcess(process) {
    this.setState({
      "render_processes": false,
      "selected_process": process.uid,
      "selected_process_properties": process.properties
    })
  }

  onChangeTitle(value) {
    this.setState({
      "demand_title": value
    });
  }

  onChangeGoal(value) {
    this.setState({
      "demand_goal": value
    });
  }

  canCreateInstruction() {
    var workflow = this.state.selected_process;
    return workflow;
  }

  formatDate(dt) {
    var dateSplited = dt.split("T")[0].split("-");
    return `${dateSplited[2]}/${dateSplited[1]}/${dateSplited[0]}`;
  }

  formatStatus(status) {
    if (status === "not_started") {
      return "Não iniciado";
    } else if (status === "in_progress") {
      return "Em andamento";
    } else if (status === "done") {
      return "Concluído";
    };
  }

  getProp(properties, propValue) {
    return properties.find(item => item.name === propValue)
  }

  formatFlows(demand) {
    var step = demand.step;
    var flows = demand.flows;

    for (var i = 0; i < flows.length; i++) {
      for (var j = 0; j < flows[i].steps.length; j++) {
        flows[i].steps[j].status = "not_started";
        if (localStorage.getItem(flows[i].steps[j].uid) !== null) {
          flows[i].steps[j].status = localStorage.getItem(flows[i].steps[j].uid);
        }
      };
    };

    var proceed = true;
    for (var i = 0; i < flows.length; i++) {
      var steps = flows[i].steps;
      for (var j = 0; j < steps.length; j++) {
        // steps[i].status = "done";
        // if (steps[i].uid === step.uid && step.status === "not_started") {
        //   steps[i].status = "in_progress";
        //   proceed = false;
        //   break;
        // };
      };
      if (proceed === false) {
        break;
      }
    }
    
    return flows;
  }

  getActivitiesProgress(demand) {
    var flows = this.formatFlows(demand);
    var completed = 0;
    var all = 0;
    
    for (var i = 0; i < flows.length; i++) {
      var steps = flows[i].steps;
      for (var j = 0; j < steps.length; j++) {
        all += 1;
        if (steps[j].status === "done") {
          completed += 1;
        }
      };
    };

    return {
      "completed": completed,
      "all": all
    }
  }

  openStatus(uid) {
    document.getElementById(uid).classList.toggle("opened");
  }

  changeStatus(uid, status) {
    const el = document.querySelector(`[data-uid="${uid}"]`);
    el.classList.remove("not_started");
    el.classList.remove("in_progress");
    el.classList.remove("done");
    el.classList.add(status);
    el.innerText = this.formatStatus(status);
    document.getElementById(uid).classList.toggle("opened");
    localStorage.setItem(uid, status)
  }

  getProcessProperties() {
    // var processes = this.state.processes;
    // return processes.find(proc => proc.uid === this.state.selected_process).properties;
    return this.state.selected_process_properties;
  }

  render() {
    var _this = this;

    const {
      messages,
      processes,
      render_processes,
      selected_process,
      creating_demand,
      all_activities_length,
      completed_activities_length,
      current_demand
    } = this.state;

    var demand = current_demand && current_demand.length > 0 && current_demand[0];

    return (
      <div className="rdp-composer-element-activities">
        <div className="rdp-composer-element-activities-overlay" onClick={() => this.props.onClose()}></div>
        <div className="rdp-composer-element-activities-modal">
          <div className="rdp-composer-element-activities-header">
            <span className="rdp-composer-element-activities-header-title">{demand ? "Instruções para a Demanda" : "Instruções para a Demanda"}</span>
            <span className="rdp-composer-element-activities-header-close" onClick={() => this.onClose()}></span>
          </div>

          <div className="rdp-composer-element-activities-body">
            {processes === null &&
              <div className="rdp-composer-element-activities-workflow-preloader"></div>
            }
            {current_demand && current_demand.length > 0 &&
              <div className="rdp-composer-element-activities-workflow-message">
                <h1 className="rdp-composer-element-activities-workflow-demand-title">{this.getProp(demand.properties, "Nome").value}</h1>
                <h1 className="rdp-composer-element-activities-workflow-demand-date">Data de criação: {this.formatDate(demand.created_at)}</h1>
                <div className="rdp-composer-element-activities-workflow-demand-progress">
                  <div className="rdp-composer-element-activities-workflow-demand-progress-bar" style={{width: `${(this.getActivitiesProgress(demand).completed / this.getActivitiesProgress(demand).all) * 100}%`}}></div>
                </div>
                <div className="rdp-composer-element-activities-workflow-demand-progress-info">
                  <span className="rdp-composer-element-activities-workflow-demand-progress-info-item">{`${this.getActivitiesProgress(demand).completed} de ${this.getActivitiesProgress(demand).all} tarefas concluídas`}</span>
                  <span className="rdp-composer-element-activities-workflow-demand-progress-info-item">{`${(this.getActivitiesProgress(demand).completed / this.getActivitiesProgress(demand).all) * 100}%`}</span>
                </div>
                <p className="rdp-composer-element-activities-workflow-demand-description">{this.getProp(demand.properties, "Objetivo").value}</p>

                <h3 className="rdp-composer-element-activities-workflow-demand-tasks-title">Tarefas relacionadas à demanda:</h3>

                {this.formatFlows(demand).map(function (flow, index) {
                  return <div key={index} className="rdp-composer-element-activities-workflow-demand-flow">
                    <span className="rdp-composer-element-activities-workflow-demand-flow-title">{flow.name}</span>
                    <ul className="rdp-composer-element-activities-workflow-demand-tasks">
                      {flow.steps.map(function (step, index) {
                        return <li key={index} className="rdp-composer-element-activities-workflow-demand-task">
                          <span className="rdp-composer-element-activities-workflow-demand-task-title">{step.name}</span>
                          <span onClick={() => _this.openStatus(step.uid)} data-uid={step.uid} className={`rdp-composer-element-activities-workflow-demand-task-status ${step.status}`}>{_this.formatStatus(step.status)}</span>
                          <div id={step.uid} className="rdp-composer-element-activities-workflow-demand-task-status-container">
                            <div onClick={() => _this.openStatus(step.uid)} className="rdp-composer-element-activities-workflow-demand-task-status-overlay"></div>
                            <ul className="rdp-composer-element-activities-workflow-demand-task-status-items">
                              <li onClick={() => _this.changeStatus(step.uid, "not_started")} className="rdp-composer-element-activities-workflow-demand-task-status-item">Não iniciado</li>
                              <li onClick={() => _this.changeStatus(step.uid, "in_progress")} className="rdp-composer-element-activities-workflow-demand-task-status-item">Em andamento</li>
                              <li onClick={() => _this.changeStatus(step.uid, "done")} className="rdp-composer-element-activities-workflow-demand-task-status-item">Concluído</li>
                            </ul>
                          </div>
                        </li>
                      })}
                    </ul>
                  </div>
                })}
              </div>
            }
            {processes &&
              <>
                {/* <div className="rdp-composer-element-activities-workflow-message">
                  <h5 className="rdp-composer-element-activities-workflow-message-title">Qual é a necessidade da demanda?</h5>
                  <span className="rdp-composer-element-activities-workflow-message-description">Defina um título para a demanda e descreva o objetivo de forma detalhada:</span>
                  <h5 className="rdp-composer-element-activities-workflow-message-label">Título:</h5>
                  <input className="rdp-composer-element-activities-workflow-message-input" type="text" ref={this.titleRef} onChange={(e) => this.onChangeTitle(e.target.value)}/>
                  <h5 className="rdp-composer-element-activities-workflow-message-label">Objetivo:</h5>
                  <textarea className="rdp-composer-element-activities-workflow-message-textarea" ref={this.goalRef} onChange={(e) => this.onChangeGoal(e.target.value)}/>
                </div> */}
                <div className="rdp-composer-element-activities-workflow-message">
                  <h5 className="rdp-composer-element-activities-workflow-message-title">Vincule um processo</h5>
                  {/* <span className="rdp-composer-element-activities-workflow-message-description">Selecione um processo :</span> */}
                  {!selected_process &&
                    <div className="rdp-composer-element-activities-workflow-message-select" onClick={() => this.onOpenWorkflows()}>Selecione um processo cadastrado</div>
                  }
                  {selected_process && processes.find(work => work.uid === selected_process) &&
                    <div className="rdp-composer-element-activities-workflow-message-select selected" onClick={() => this.onOpenWorkflows()}>{processes.find(work => work.uid === selected_process).name}</div>
                  }
                  
                  {selected_process && this.getProcessProperties().length > 0 &&
                    <div className="rdp-composer-element-activities-workflows-processes">
                      <span className="rdp-composer-element-activities-workflows-processes-title">Informações Exigidas Pelo Processo</span>
                      <p className="rdp-composer-element-activities-workflows-processes-description">
                        Os campos abaixos são exigidos para o processo vinculado, nesta etapa você pode pré-prencher ou deixar em branco para ser preenchido na solicitação da demanda.
                      </p>
                      {this.getProcessProperties().map(function (property, index) {
                        return <div key={index} className="rdp-composer-element-activities-workflows-process">
                          <span className="rdp-composer-element-activities-workflows-process-label">{property.name}</span>
                          {property.type === "Text" &&
                            <input type="text" key={property.uid} defaultValue={property.value} className="rdp-composer-element-activities-workflows-process-input" onChange={(e) => _this.onChangeProcessPropertyValue(property.uid, e.target.value)}/>
                          }
                          {property.type === "DateTime" &&
                            <input type="date" key={property.uid} defaultValue={property.value} className="rdp-composer-element-activities-workflows-process-input" onChange={(e) => _this.onChangeProcessPropertyValue(property.uid, e.target.value)}/>
                          }
                        </div>
                      })}
                    </div>
                  }
                  
                  
                </div>
                <button className={`rdp-composer-element-activities-workflow-message-button ${this.canCreateInstruction() ? "active" : ""}`} onClick={() => this.createInstruction()}>Salvar instruções</button>
              </>
            }
            {creating_demand && current_demand !== null && current_demand.length === 0 &&
              <>
                <div className="rdp-composer-element-activities-workflow-creating-demand">
                  
                  <div className="rdp-composer-element-activities-workflow-creating-demand-clock"></div>
                  <h1 className="rdp-composer-element-activities-workflow-creating-demand-title">Aguarde, a demanda está sendo criada...</h1>
                  {/* <div className="rdp-composer-element-activities-workflow-creating-demand-activities-progress">
                    <div className="rdp-composer-element-activities-workflow-creating-demand-activities-progress-bar" style={{width: `${(completed_activities_length / all_activities_length) * 100}%`}}></div>
                  </div>
                  <span className="rdp-composer-element-activities-workflow-creating-demand-activities-progress-length">{`${completed_activities_length} de ${all_activities_length} tarefas criadas`}</span> */}
                </div>
              </>
            }
          </div>

          <ul className="rdp-composer-element-activities-items">
            {messages && this.props.users && this.renderMessages().map(function (item, index) {
              return <li key={index} className={`rdp-composer-element-activities-item ${item.my ? "me" : "another"}`}>
                <div className="rdp-composer-element-activities-item-avatar">
                  {_this.getNameInitials(item.user.detail.first_name, item.user.detail.last_name)}
                </div>
                <div className="rdp-composer-element-activities-item-data">
                  <span className="rdp-composer-element-activities-item-author">{item.user.detail.name}</span>
                  <span className="rdp-composer-element-activities-item-message">{item.message}</span>
                </div>
              </li>
            })}
          </ul>

          {render_processes &&
            <div className="rdp-composer-element-activities-workflows">
              <div className="rdp-composer-element-activities-workflows-overlay" onClick={() => this.onCloseWorkflows()}></div>

              <div className="rdp-composer-element-activities-workflows-body">
                <div className="rdp-composer-element-activities-workflows-header">
                  <span className="rdp-composer-element-activities-workflows-header-back" onClick={() => this.onCloseWorkflows()}></span>
                  <span className="rdp-composer-element-activities-workflows-header-title">Selecione um processo cadastrado</span>
                </div>
                {processes &&
                  <ul className="rdp-composer-element-activities-workflows-items">
                    {processes.map(function (workflow, index) {
                      return <li key={index} className={`rdp-composer-element-activities-workflows-item ${workflow.uid === selected_process ? "active" : ""}`} onClick={() => _this.selectProcess(workflow)}>{workflow.name}</li>
                    })}
                  </ul>
                }
              </div>
            </div>
          }

          {/* {!this.renderMessages() &&
            <div className="rdp-composer-element-activities-preloader-box">
              <div>
                <svg version="1.1" xmlns="http://www.w3.org/2000/svg" width="768" height="768" viewBox="0 0 768 768">
                  <path fill="#212b36" d="M704 480v-320c0-26.496-10.784-50.56-28.128-67.872s-41.376-28.128-67.872-28.128h-448c-26.496 0-50.56 10.784-67.872 28.128s-28.128 41.376-28.128 67.872v512c0 8.192 3.136 16.384 9.376 22.624 12.512 12.512 32.768 12.512 45.248 0l118.624-118.624h370.752c26.496 0 50.56-10.784 67.872-28.128s28.128-41.376 28.128-67.872zM640 480c0 8.832-3.552 16.8-9.376 22.624s-13.792 9.376-22.624 9.376h-384c-8.832 0-16.832 3.584-22.624 9.376l-73.376 73.376v-434.752c0-8.832 3.552-16.8 9.376-22.624s13.792-9.376 22.624-9.376h448c8.832 0 16.8 3.552 22.624 9.376s9.376 13.792 9.376 22.624z"></path>
                </svg>
                <span className="rdp-composer-element-activities-preloader"></span>
                <span className="rdp-composer-element-activities-preloader-message">Sincronizando mensagens, aguarde...</span>
              </div>
            </div>
          } */}
        </div>
      </div>
    );
  }
}
